<template>
<m-pageframe
    title="{organization_label}: Club Customization Bulk Message Results Summary"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>
   <v-alert
      border="left"
      colored-border
      color="primary"
      elevation="2"
      type="info"
      dismissible
    >
      Club customization analytics are not real time &mdash; it typically takes a day (24 hours) for club customizations to be attributed
   </v-alert>

    <m-edit-time-period
        v-model="analytics_time_period"
        v-on:input="onChangeAnalyticsPeriod"
        :show_time_bin_by="false"
    />

    <v-row
        v-if="report != null"
    >
       <v-col>
            <div class="total-card">
                <p class="total-value">{{report.day_count}} Days</p>
                <p class="total-label">{{report.date_range}}</p>
            </div>
       </v-col>

        <v-col>
            <div class="total-card">
                <p class="total-value">{{$rc.pretty(report.results.length,'integer')}}</p>
                <p class="total-label">
                    Bulk Messages <span v-if="report.results.length != part_total">({{part_total}} parts)</span>
                  </p>
            </div>
        </v-col>

        <v-col>
            <div class="total-card">
                <p class="total-value">{{$rc.pretty(report.total_recipients,'integer')}}</p>
                <p class="total-label">Messages Sent</p>
            </div>
        </v-col>

        <v-col>
            <div class="total-card">
                <p class="total-value">{{$rc.pretty(report.total_link_click_count,'integer')}}</p>
                <p class="total-label">Magic Link Click Count</p>
            </div>
        </v-col>

        <v-col
          v-if="report != null && report.order_attribution_supported"
        >
            <div class="total-card">
                <p class="total-value">{{$rc.pretty(report.total_value_millicents,'millicents_whole_dollars')}}</p>
                <p class="total-label">Total Attributed Order Value</p>
            </div>
        </v-col>
    </v-row>

    <v-text-field
      autocomplete="off"
      label="Search"
      prepend-icon="mdi-magnify"
      v-model="full_text"
      v-on:input="update"
    >
      <v-menu
        bottom
        offset-y
        slot="append-outer"
      >
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
          >
            mdi-dots-vertical
          </v-icon>
        </template>
    
        <v-list>
          <v-list-item
            v-on:click="onClickExportAllBulkMessageOptOutCounts"
          >
            <v-list-item-title>Export All Bulk Message Opt Out Counts...</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> 
    </v-text-field>

    <v-data-table
      v-if="report != null"
      :search="full_text"
      :headers="headers"
      :items="report.results"
      :items-per-page="10000"
      class="elevation-1"
      :hide-default-footer="true"
      :footer-props="{
        disableItemsPerPage: false,
        disablePagination: false,
      }"

      :sort-by.sync="sort_by"
      :sort-desc.sync="sort_desc"
    >
    
      <template v-slot:item.sent_count="{ item }">
        {{$rc.pretty(item.sent_count,'integer')}}
      </template>

      <template v-slot:item.comp_conversion_rate="{ item }">
        {{item.comp_conversion_rate == null ? null : item.comp_conversion_rate + '%'}}
      </template>

      <template v-slot:item.order_count="{ item }">
        {{$rc.pretty(item.order_count,'integer')}}
      </template>

      <template v-slot:item.order_value="{ item }">
        {{$rc.pretty(item.order_value,'millicents_whole_dollars')}}
      </template>

      <template v-slot:item.order_attribution_settings_label="{ item }">
        <a style="text-decoration: underline" v-on:click="onClickOrderAttributionSettingsLabel(item)">{{item.order_attribution_settings_label}}</a>
      </template>

    

      <template v-slot:item.action="{ item }">
        <v-menu 
          bottom 
          offset-y  
        >
        
        <template v-slot:activator="{ on }">
            
          <v-icon 
            v-on="on"
          >
            mdi-dots-vertical-circle-outline
          </v-icon>
            
        </template>
        
        <v-list>
          <v-list-item
            v-on:click="onClickDetails(item)"
          >
            <v-list-item-title>Details...</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="item.bulk_message_part_count == 1"
            v-on:click="onClickSendStatus(item)"
          >
            <v-list-item-title>Send Status...</v-list-item-title>
          </v-list-item>
        
        </v-list>
        
        </v-menu> 
      </template>
    
    </v-data-table>

      

    <m-order-attribution-settings-dialog
      ref="order-attribution-settings-dialog"
      v-on:update="onChangeAnalyticsPeriod"
    />

 

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

  data() {
    return {
      analytics_time_period: { 'period': 'trailing-twelve-months' },
      report: null,
      'sort_by': ['order_value','date_send_start'],
      'sort_desc': [true,true],
      full_text: null,
    }
  },

  methods: {
    onChangeAnalyticsPeriod() {
      this.$rc.rest({
        'spinner': true,
        'endpoint': 'PUT: /api/v1/analytics/run-report/club-customization-summary',
      
        'params' : {
            ...this.analytics_time_period
          },
      
        'on_success': (data) => {
            this.report = data;

            
          },
      
        'on_error': 'Unable to download bulk message results summary report',
      });
    },

    onClickDefaultOrderTypes()
    {
        this.$router.push({
            'name': 'settings-organization-order-attribution',
            'params' : {
                'organization_id': this.$rc.getOrganizationId()
            }
        });
    },

    onClickDetails(item)
    {
      this.$router.push({
        'name': 'analytics-one-bulk-message-analytics-group',
        'params' : {
          'organization_id': item.organization_id,
          'analytics_group_id': item.analytics_group_id,
        }
      });
    },

    onClickSendStatus(item)
    {
      this.$router.push({
        'name': 'view-bulk-message-send-summary',
        'params': {
          'organization_id': item.organization_id,
          'bulk_message_id': item.analytics_group_id,
        }
      }).catch(e => { }); // swallow any exception
    },

    onClickOrderAttributionSettingsLabel(item)
    {
      this.$refs['order-attribution-settings-dialog'].showDialog(item.analytics_group_id, item.order_attribution_settings_id);
    },

    onClickExportAllBulkMessageOptOutCounts()
    {
      this.$rc.excelExport(
          'EXPORT: /api/v1/analytics/run-report/bulk-message-opt-out-counts',
          {
            'organization_id': this.$route.params.organization_id,
          }
        );
    },
  },

  computed: {
    headers() {
      let order_attribution_supported = this.report == null ? false : this.report.order_attribution_supported;

      let ret = [];

      ret.push({ text: 'Send Start', value: 'date_send_start'});
      ret.push({ text: 'Label', value: 'analytics_group_label'});

      if ( order_attribution_supported )
      {
        ret.push({ text: 'Attribution Settings', value: 'order_attribution_settings_label'});
      }

      ret.push({ text: 'Parts', value: 'bulk_message_part_count'});
      ret.push({ text: 'Messages Sent', value: 'sent_count'});

      if ( order_attribution_supported )
      {
          //ret.push({ text: 'Conversion (%)', value: 'comp_conversion_rate'});
          ret.push({ text: 'Magic Link Click (count)', value: 'link_click_count'});
          ret.push({ text: 'Customization (count)', value: 'order_count'});
          ret.push({ text: 'Customization (inc. $)', value: 'order_value'});
          ret.push({ text: 'Action', value: 'action'});
      }


      return ret;
    },

    part_total() {
      if ( this.report == null ) return 0;

      return this.report.results
                .map((el) => el.bulk_message_part_count)
                .reduce((x,y) => x + y, 0);
    },
  },
  
}
</script>

<style lang="scss" scoped>
.total-card
{
    border: 1px solid rgba(0,0,0,0.15);
    
    padding-top: 30px;
    padding-bottom: 30px;

    padding-left: 15px;
    padding-right: 15px;
    text-align: center;

    margin-bottom: 15px;
}

.total-value
{
    font-weight: 700;
    font-size: 28px;
}

.total-label
{
    margin-bottom: -15px;
}
</style>